<div class="mediacontainer" #mediacontainer>
    <video controls #video id="my-player" class="video-js vjs-default-skin vjs-big-play-centered" preload="metadata" playsinline [ngStyle]="{display: media.type.startsWith('video') ? 'inherit': 'none'}"></video>
    <div [ngStyle]="{display: media.type.startsWith('audio') ? 'inherit': 'none'}">
        <br><br>
        <audio controls #audio preload="metadata"></audio>
    </div>
</div>